import { useEffect, useRef } from 'react';
//import styles from './CommandLog.module.css';
import styles from '../../Assets/Styles/Joystick/CommandLog.module.css';

export default function CommandLog({ logs, onClear }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [logs]);

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <span className={styles.title}>▤ COMMAND LOG</span>
        <button className={styles.clrBtn} onClick={onClear}>CLR</button>
      </div>
      <div className={styles.log} ref={ref}>
        {logs.length === 0 && (
          <div className={styles.empty}>System ready — connect MQTT to begin<span className={styles.blink}>_</span></div>
        )}
        {logs.map((l) => (
          <div key={l.id} className={styles.entry}>
            <span className={styles.ts}>{l.ts}</span>
            <span className={`${styles.msg} ${styles[l.type]}`}>{l.msg}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
